import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import Markdown from "@irati/ui/src/Markdown"
import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import {READY_TO_LAUNCH,
  IN_PROGRESS,
  LAUNCHED,
  STOPPED,
  SAVED_AS_DRAFT,
  VALIDATION_STATUS_DRAFT,
  ARCHIVED} from "@irati/insights/constants/schedule"
import Icon from "@irati/ui/src/Icon"

import {isNextTriggerAtInThePast} from "../../../helpers/schedule"
import {ALERT_RED_COLOR} from "../../../ui/colors"

const DATE_FORMAT = {
  day: "2-digit",
  month: "2-digit",
  year: "2-digit",
  hour: "2-digit",
  minute: "2-digit"
}

const Wrapper = styled.div`
  display: flex;
`

const IconWrapper = styled(Icon)`
  margin-right: 7px;
  flex-shrink: 0;
  height: 23px;
  display: flex;
  justify-content: center;
`

class ScheduleDescription extends Component {
  static propTypes = {
    schedule: PropTypes.object,
    intl: PropTypes.object.isRequired,
    formatMessage: PropTypes.func.isRequired
  }
  static defaultProps = {
    schedule: {}
  }

  determineStatusDescription = (intl, schedule) => {
    const validationStatus = schedule.validationStatus
    const startAt = intl.formatDate(schedule.startAt, DATE_FORMAT)
    const nextTriggerAt = intl.formatDate(schedule.nextTriggerAt, DATE_FORMAT)
    const {formatMessage} = this.props
    const nextTriggerIsInThePast = isNextTriggerAtInThePast(schedule)


    switch (validationStatus) {
      case READY_TO_LAUNCH:
        return formatMessage({id: "insights.schedule.description.readyToLaunch"}, {startAt})
      case LAUNCHED:
        return formatMessage(
          {id: "insights.schedule.description.launched"},
          {startAt})
      case IN_PROGRESS:
        return formatMessage(
          {id: "insights.schedule.description.inProgress"},
          {nextTriggerAt})
      case STOPPED:
        return formatMessage({id: "insights.schedule.description.stopped"})
      case ARCHIVED:
        return formatMessage({id: "insights.schedule.description.archived"})
      case SAVED_AS_DRAFT:
        return nextTriggerIsInThePast
          ? formatMessage({id: "insights.schedule.description.savedAsDraft.startDateInPast"})
          : formatMessage({id: "insights.schedule.description.savedAsDraft.missingInfo"})
      default:
        return formatMessage({id: "insights.schedule.description.savedAsDraft.missingInfo"})
    }
  }


  render() {
    const idNamespace = id("scheduleDescription", this.props)
    const {schedule, intl} = this.props
    const shouldDisplayIcon = VALIDATION_STATUS_DRAFT.includes(schedule.validationStatus)
    const {validationStatus, runOnce} = schedule
    const showDescription = !(runOnce && validationStatus === STOPPED)

    return (
      <Wrapper id={idNamespace}>
        {shouldDisplayIcon && <IconWrapper icon="i" color={ALERT_RED_COLOR} size={14} />}
        {showDescription && <Markdown source={this.determineStatusDescription(intl, schedule)} />}
      </Wrapper>
    )
  }
}

export default injectIntl(ScheduleDescription)
